import * as React from "react";
import { RankingBarChart } from "./RankingBarChart";

interface Datum {
  name: string;
  value: number;
}

interface Props {
  data: Datum[];
  color: string;
  xAxisTitle: string;
  caption?: string;
}

const AXIS_TICK_STEP = 5;

const formatValueLabel = (value: number) => `${value}%`;
const formatTooltipValue = (value: number) => `${Math.round(value)}% comfort`;

export const SiteComfortRankingBarChart: React.FC<Props> = ({
  data,
  color,
  xAxisTitle,
  caption,
}) => (
  <RankingBarChart
    data={data}
    color={color}
    xAxisTitle={xAxisTitle}
    caption={caption}
    tickStep={AXIS_TICK_STEP}
    tooltipFormatter={formatTooltipValue}
    valueLabelFormatter={formatValueLabel}
  />
);
